import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MustMatch } from '../../../../shared/_helpers/must-match.validator';
import Swal from 'sweetalert2';
import { TokenStorageService } from '../../services/token-storage.service';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  signupForm: FormGroup;
  loading = false;
  errorMessage: string;
  isSuccessful = false;
  isSignUpFailed = false;
  submitted = false;
  fiscalmatPattern = "^[0-9]{8}$" 
  indicatifPattern = "^[0-9]{3}$" 
  fieldTextType: boolean;
  repeatFieldTextType: boolean;
  isLoggedIn: boolean;
  currentuser: User;
  role: string;
  usertype: string;
  username: string;
  lastname: string;
  nature: string;
  raisonsociale: string;
  indicatifagence: string;
  codebanque: string;
  login: string;
  signupFormsuperadmin: FormGroup<any>;
  signupFormadminbanque: FormGroup<any>;
  signupFormadmincomite: FormGroup<any>;
  user: User;

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private auth: AuthService,
              private Auth: TokenStorageService,
              private userservice: UserService,
              ) { }

              ngOnInit() {
                this.initializeSignupForm();
              
                this.isLoggedIn = !!this.Auth.getToken();
              
                if (this.isLoggedIn) {
                  this.currentuser = this.Auth.getUser();
              
                  this.userservice.getUserById(this.currentuser.userId).then((user: User) => {
                    this.role = user.role;
              this.user=user
                    this.initializeSignupFormSuperadmin(user);
                    this.initializeSignupFormAdminBanque(user);
                    this.initializeSignupFormadmincomite(user);

                    this.subscribeToResponsableChanges();
                  });
                }
                else{
                  this.initializeSignupForm()
                }
              }
              
              private initializeSignupForm() {
                this.signupForm = this.formBuilder.group({
                  email: [null, [Validators.required, Validators.email]],
                  password: [null, Validators.required],
                  confirmpassword: [null, Validators.required],
                  firstname: [null, Validators.required],
                  confirmemail: [null, Validators.required],
                  indicatif: ["216"],
                  mobile: [null],
                  confirmmobile: [null],
                  banque: ["00110"],
                  usertype: [null, Validators.required],
                  userType: [null],
                  lastname: [null, Validators.required],
                  clientcode: [this.randomString(), Validators.required],
                  role: [{ value: "basic", disabled: true }, Validators.required],
                }, {
                  validator: [MustMatch('email', 'confirmemail'), MustMatch('mobile', 'confirmmobile')]
                });
              }
              
              private initializeSignupFormSuperadmin(user: User) {
                this.signupFormsuperadmin = this.formBuilder.group({
                  email: [null, [Validators.required, Validators.email]],
                  password: [null, Validators.required],
                  confirmpassword: [null, Validators.required],
                  firstname: [null, Validators.required],
                  confirmemail: [null, Validators.required],
                  usertype: [null, Validators.required],
                  userType: [null],
                  lastname: [null, Validators.required],
                  clientcode: [this.randomString(), Validators.required],
                  role: [null, Validators.required],
                  banque: [null, Validators.required],
                  responsable: [null, Validators.required],
                }, {
                  validator: [MustMatch('email', 'confirmemail')]
                });
              }
              
              private initializeSignupFormAdminBanque(user: User) {
                this.signupFormadminbanque = this.formBuilder.group({
                  email: [null, [Validators.required, Validators.email]],
                  password: [null, Validators.required],
                  confirmpassword: [null, Validators.required],
                  firstname: [null, Validators.required],
                  confirmemail: [null, Validators.required],
                  usertype: [null, Validators.required],
                  userType: [null],
                  lastname: [null, Validators.required],
                  clientcode: [this.randomString(), Validators.required],
                  indicatifagence: [null],
                  carte: [null],
                  compte: [null],
                  affiliation: [null],
                  terminal: [null],
                  banque: [user.banque],
                  role: [{ value: "userbanque", disabled: true }, Validators.required],
                }, {
                  validator: [MustMatch('email', 'confirmemail')]
                });
              }
              private initializeSignupFormadmincomite(user: User) {
                this.signupFormadmincomite = this.formBuilder.group({
                  email: [null, [Validators.required, Validators.email]],
                  password: [null, Validators.required],
                  confirmpassword: [null, Validators.required],
                  firstname: [null, Validators.required],
                  confirmemail: [null, Validators.required],
                  usertype: ['comite arbitrage', Validators.required],
                  userType: [null],
                  lastname: [null, Validators.required],
                  clientcode: [this.randomString(), Validators.required],
                  role: ['usercomite', Validators.required],
                  banque: [null, Validators.required]
                }, {
                  validator: [MustMatch('email', 'confirmemail')]
                });
              } 
              private subscribeToResponsableChanges() {
                console.log(this.signupFormsuperadmin.get('responsable'))
                this.signupFormsuperadmin.get('responsable')?.valueChanges.subscribe(responsableValue => {
                  if (responsableValue === 'user') {
                    this.signupFormsuperadmin.get('role')?.setValue('adminbanque');
                    this.signupFormsuperadmin.get('usertype')?.setValue('Metier');
                  } else if (responsableValue === 'comite') {
                    this.signupFormsuperadmin.get('role')?.setValue('admincomite');
                    this.signupFormsuperadmin.get('usertype')?.setValue('comite arbitrage');
                    this.signupFormsuperadmin.get('banque')?.setValue('none');

                  }
                });
              }
              
  get f() { return this.signupForm.controls; }
  get fsuperadmin() { return this.signupFormsuperadmin.controls; }
  get fadminbanque() { return this.signupFormadminbanque.controls; }
  get fadmincomite() { return this.signupFormadmincomite.controls; }

  randomString() :any{
    var chars = "ABCDEFGHIJKLMNOPQRSTUVW";
    var string_length = 1;
    var randomstring = '';
    var chars2 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZ";
    var string_length2 = 2;
    var randomstring2 = '';
    for (var i=0; i<string_length; i++) {
      var rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum,rnum+1);
    }
    for (var j=0; j<string_length2; j++) {
      var rnum2= Math.floor(Math.random() * chars2.length);
      randomstring2 += chars2.substring(rnum2,rnum2+1);
    }
   /* this.signupFormsuperadmin?.patchValue({clientcode: randomstring+randomstring2});
    this.signupForm?.patchValue({clientcode: randomstring+randomstring2});
    this.signupFormadminbanque?.patchValue({clientcode: randomstring+randomstring2});*/
return randomstring+randomstring2
  }
  onSignup() {
    this.loading = true;
    this.submitted = true;

    if (this.signupForm.invalid) {
      
      return this.loading = false;
  }
    const email = this.signupForm.get('email').value;
    const usertype = this.signupForm.get('usertype').value; 
    const mobile = this.signupForm.get('indicatif').value+this.signupForm.get('mobile').value;
    const password = this.signupForm.get('password').value;
    const confirmpassword = this.signupForm.get('confirmpassword').value;
    const firstname = this.signupForm.get('firstname').value;
    const lastname = this.signupForm.get('lastname').value;
    const clientcode = this.signupForm.get('clientcode').value;
    const role = this.signupForm.get('role').value;
    const banque = this.signupForm.get('banque').value;
    const userType = this.signupForm.get('userType').value??'smt';

    this.auth.register(email, password,confirmpassword,usertype,mobile,firstname,lastname,clientcode,role,banque,userType).subscribe({

      next: data => {
        this.isSuccessful = true;
        this.isSignUpFailed = false;
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'inscription réalisée avec succès, veuillez cliquer sur le lien de vérification envoyé à votre adresse Email pour pouvoir se connecter',
          showConfirmButton: false,
          
        });
        
        
        this.loading = false;
        this.router.navigate(['/auth/login']);
      },
      error: error => {
        this.loading=false;
          
      }
    });

  }
  onReset() {
    this.submitted = false;
    this.signupForm.reset();
this.initializeSignupForm()
this.initializeSignupFormSuperadmin(this.user);
this.initializeSignupFormAdminBanque(this.user);
this.initializeSignupFormadmincomite(this.user);
}
onSignupsuperadmin() {
  this.loading = true;
  this.submitted = true;
console.log(this.signupFormsuperadmin)
  if (this.signupFormsuperadmin.invalid) {
    
    return this.loading = false;
}
  const email = this.signupFormsuperadmin.get('email').value;
  const usertype = this.signupFormsuperadmin.get('usertype').value; 
  const password = this.signupFormsuperadmin.get('password').value;
  const confirmpassword = this.signupFormsuperadmin.get('confirmpassword').value;
  const firstname = this.signupFormsuperadmin.get('firstname').value;
  const lastname = this.signupFormsuperadmin.get('lastname').value;
  const clientcode = this.signupFormsuperadmin.get('clientcode').value;
  const role = this.signupFormsuperadmin.get('role').value;
  const banque = this.signupFormsuperadmin.get('banque').value;
  const userType = this.signupFormsuperadmin.get('userType').value??'smt';
  this.auth.registersuperadmin(email, password,banque,confirmpassword,usertype,firstname,lastname,clientcode,role,userType).subscribe({
    next: data => {
      this.isSuccessful = true;
      this.isSignUpFailed = false;
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'création réalisée avec succès!',
        showConfirmButton: false,
        
      });
      
      
      this.loading = false;
      this.router.navigate(['/dashboard/admin-board']);
    },
    error: error => {
      this.loading=false;
        
    }
  });

}
onResetsuperadmin() {
  this.submitted = false;
  this.signupFormsuperadmin.reset();
  this.initializeSignupForm()
  this.initializeSignupFormSuperadmin(this.user);
  this.initializeSignupFormAdminBanque(this.user);
  this.initializeSignupFormadmincomite(this.user);
}
onSignupadminbanque() {
  this.loading = true;
  this.submitted = true;
  if (this.signupFormadminbanque.invalid) {
    
    return this.loading = false;
}
  const email = this.signupFormadminbanque.get('email').value;
  const usertype = this.signupFormadminbanque.get('usertype').value; 
  const password = this.signupFormadminbanque.get('password').value;
  const confirmpassword = this.signupFormadminbanque.get('confirmpassword').value;
  const firstname = this.signupFormadminbanque.get('firstname').value;
  const lastname = this.signupFormadminbanque.get('lastname').value;
  const clientcode = this.signupFormadminbanque.get('clientcode').value;
  const role = this.signupFormadminbanque.get('role').value;
  const affiliation = this.signupFormadminbanque.get('affiliation').value;
  const terminal = this.signupFormadminbanque.get('terminal').value;
  const carte = this.signupFormadminbanque.get('carte').value;
  const compte = this.signupFormadminbanque.get('compte').value;
  const indicatifagence = this.signupFormadminbanque.get('indicatifagence').value;
  const banque = this.signupFormadminbanque.get('banque').value;
  const userType = this.signupFormadminbanque.get('userType').value??'smt';

  this.auth.registeradminbanque(email,carte,affiliation,banque,indicatifagence,terminal, password,confirmpassword,usertype,firstname,lastname,clientcode,role,compte,userType).subscribe({

    next: data => {
      this.isSuccessful = true;
      this.isSignUpFailed = false;
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'création réalisée avec succès',
        showConfirmButton: false,
        
      });
      
      
      this.loading = false;
      this.router.navigate(['/dashboard/admin-board']);
    },
    error: error => {
      this.loading=false;
        
    }
  });

}
onResetadminbanque() {
  this.submitted = false;
  this.signupFormadminbanque.reset();
  this.initializeSignupForm()
  this.initializeSignupFormSuperadmin(this.user);
  this.initializeSignupFormAdminBanque(this.user);
  this.initializeSignupFormadmincomite(this.user);}
onSignupadmincomite() {
  this.loading = true;
  this.submitted = true;
  if (this.signupFormadmincomite.invalid) {
    
    return this.loading = false;
}
  const email = this.signupFormadmincomite.get('email').value;
  const usertype = this.signupFormadmincomite.get('usertype').value; 
  const password = this.signupFormadmincomite.get('password').value;
  const confirmpassword = this.signupFormadmincomite.get('confirmpassword').value;
  const firstname = this.signupFormadmincomite.get('firstname').value;
  const lastname = this.signupFormadmincomite.get('lastname').value;
  const clientcode = this.signupFormadmincomite.get('clientcode').value;
  const role = this.signupFormadmincomite.get('role').value;
  const affiliation = '';
  const terminal = '';
  const carte = '';
  const compte = '';
  const indicatifagence = '';
  const banque = this.signupFormadmincomite.get('banque').value;
  const userType = this.signupFormadmincomite.get('userType').value??'smt';

  this.auth.registeradmincomite(email,carte,affiliation,banque,indicatifagence,terminal, password,confirmpassword,usertype,firstname,lastname,clientcode,role,compte,userType).subscribe({

    next: data => {
      this.isSuccessful = true;
      this.isSignUpFailed = false;
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'création réalisée avec succès',
        showConfirmButton: false,
        
      });
      
      
      this.loading = false;
      this.router.navigate(['/dashboard/admin-board']);
    },
    error: error => {
      this.loading=false;
        
    }
  });

}
onResetadmincomite() {
  this.submitted = false;
  this.signupFormadmincomite.reset();
  this.initializeSignupForm()
  this.initializeSignupFormSuperadmin(this.user);
  this.initializeSignupFormAdminBanque(this.user);
  this.initializeSignupFormadmincomite(this.user);
}
toggleFieldTextType() {
  this.fieldTextType = !this.fieldTextType;
}

togglerepeatFieldTextType() {
  this.repeatFieldTextType = !this.repeatFieldTextType;
}
}